/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Widget_Today_EyebrowInputs */

const en_us2_native_release_widget_today_eyebrow = /** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today's workout`)
};

const pt_br2_native_release_widget_today_eyebrow = /** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino de hoje`)
};

const pt_pt2_native_release_widget_today_eyebrow = /** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino de hoje`)
};

/** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */
const es_419_native_release_widget_today_eyebrow = en_us2_native_release_widget_today_eyebrow;

/** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */
const fr_fr2_native_release_widget_today_eyebrow = en_us2_native_release_widget_today_eyebrow;

/** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */
const de_de2_native_release_widget_today_eyebrow = en_us2_native_release_widget_today_eyebrow;

/** @type {(inputs: Native_Release_Widget_Today_EyebrowInputs) => LocalizedString} */
const it_it2_native_release_widget_today_eyebrow = en_us2_native_release_widget_today_eyebrow;

/**
* | output |
* | --- |
* | "Today's workout" |
*
* @param {Native_Release_Widget_Today_EyebrowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_widget_today_eyebrow = /** @type {((inputs?: Native_Release_Widget_Today_EyebrowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Widget_Today_EyebrowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_widget_today_eyebrow(inputs)
	if (locale === "es-419") return es_419_native_release_widget_today_eyebrow(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_widget_today_eyebrow(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_widget_today_eyebrow(inputs)
	if (locale === "de-DE") return de_de2_native_release_widget_today_eyebrow(inputs)
	if (locale === "it-IT") return it_it2_native_release_widget_today_eyebrow(inputs)
	return en_us2_native_release_widget_today_eyebrow(inputs)
});
export { native_release_widget_today_eyebrow as "native-release.widget_today_eyebrow" }